import React from 'react'
import {fromJS} from 'immutable'
import {connect} from 'react-redux'
import moment from 'moment'

import formatShortDay from './data/formatters/short_day'
import formatShortTimeOfDay from './data/formatters/short_time_of_day'
import {watchUserSchedule, unwatchUserSchedule} from './data/watchers/schedule'
import createFutureSessionWithExpert from './data/setters/create_future_session_with_expert'

class SessionBookLater extends React.Component {
  constructor (props) {
    super(props)

    this.state = {}

    this.onDaySelect = this.onDaySelect.bind(this)
    this.onSessionTimeSelect = this.onSessionTimeSelect.bind(this)
    this.onSessionLengthSelect = this.onSessionLengthSelect.bind(this)
    this.onSessionSubmit = this.onSessionSubmit.bind(this)

    this.proceedToSessionBook = this.proceedToSessionBook.bind(this)
  }

  componentWillMount () {
    this.props.onComponentLoaded(this.props.expert.get('uid'))
  }

  componentWillUnmount () {
    this.props.onComponentUnLoaded()
  }

  proceedToSessionBook (sessionId) {
    if (sessionId) {
      const requestData = fromJS({
        sessionLength: this.state.selectedSessionLength,
        startTime: this.state.selectedSessionTime,
        type: 'later'
      })

      this.props.onSessionBook({sessionId, requestData})
    }
  }

  onDaySelect (e) {
    const selectedDay = e.target.value

    this.setState({selectedDay})
  }

  onSessionTimeSelect (e) {
    const selectedSessionTime = parseInt(e.target.value, 10)

    if (typeof(selectedSessionTime) === 'number') {
      this.setState({selectedSessionTime})
    }
  }

  onSessionLengthSelect (e) {
    const selectedSessionLength = parseInt(e.target.value, 10)

    if (typeof(selectedSessionLength) === 'number') {
      this.setState({selectedSessionLength})
    }
  }

  onSessionSubmit (e) {
    if (e && e.preventDefault) e.preventDefault()

    const startTime = this.state.selectedSessionTime
    const sessionLength = this.state.selectedSessionLength

    this.props.createFutureSessionWithExpert(
      this.props.expert,
      this.props.currentUser,
      sessionLength, startTime
    )
    .then(this.proceedToSessionBook)
  }

  shouldBookButtonDisabled () {
    if (!this.state.selectedDay || !this.state.selectedSessionTime || !this.state.selectedSessionLength) return true

    return false
  }

  renderAvailableTimeOptions () {
    if (this.state.selectedDay) {
      return this.props.expertSchedule.getIn([this.state.selectedDay, 'slots'])
        .filter((slot) => slot.available === true)
        .filter((slot) => slot.startTime.isSameOrAfter(moment()))
        .map((slot) => <option key={slot.startTime.valueOf()} value={slot.startTime.valueOf()}>{formatShortTimeOfDay(slot.startTime)}</option>)
    }
  }

  renderAvailableDays () {
    return this.props.expertSchedule
      .toList()
      .sortBy((dayEntry) => dayEntry.get('index'))
      .map((dayEntry) => <option key={dayEntry.get('index')} value={dayEntry.get('index')}>{formatShortDay(dayEntry.get('day'))}</option>)
  }

  renderInnerSection () {
    if (this.props.expertSchedule && this.props.expertSchedule.size > 0) {
      return (
        <div className='form'>
          <div className='form-section'>
            <select style={{width: 250}} onChange={this.onDaySelect}>
              <option key={-1} value='' disabled selected>Select day</option>
              {this.renderAvailableDays()}
            </select>
          </div>
          <div className='form-section' onChange={this.onSessionTimeSelect}>
            <select style={{width: 250}} disabled={!this.state.selectedDay}>
              <option key={-1} value='' disabled selected>Select time</option>
              {this.renderAvailableTimeOptions()}
            </select>
          </div>
          <div className='form-section' onChange={this.onSessionLengthSelect}>
            <select style={{width: 250}} disabled={!this.state.selectedDay}>
              <option key={-1} value='' disabled selected>Select your session length</option>
              {
                this.props.sessionLengths.map((s) => {
                  return <option key={s.get('value')} value={s.get('value')}>{s.get('label')}</option>
                })
              }
            </select>
          </div>
          <div className='form-section'>
            <button className='button success' style={{width: 250}} disabled={this.shouldBookButtonDisabled()} onClick={this.onSessionSubmit}>Book</button>
          </div>
        </div>
      )
    }
    else if (this.props.expertSchedule) {
      return (
        <p>We're sorry, this expert has not scheduled available time yet.</p>
      )
    }
    else {
      return (
        <p>Loading...</p>
      )
    }
  }

  render () {
    return (
      <div>
        <p>Book a paid session for later.</p>
        <p className='text-warning' style={{color: '#8a6929', fontSize: 12}}>You are seeing expert's available times in your local time zone.</p>
        {this.renderInnerSection()}
      </div>
    )
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    expertSchedule: state.getIn(['schedules', ownProps.expert.get('uid'), 'mapped']),
    sessionLengths: state.getIn(['chatSettings', 'sessionPaymentLengths'])
  }
}

const mapDispatchToProps = () => {
  return {
    onComponentLoaded: watchUserSchedule,
    onComponentUnLoaded: unwatchUserSchedule,
    createFutureSessionWithExpert: createFutureSessionWithExpert
  }
}

const SessionBookLaterContainer = connect(
  mapStateToProps, mapDispatchToProps
)(SessionBookLater)

export default SessionBookLaterContainer



/** WEBPACK FOOTER **
 ** ./modules/shared/session_book_later.js
 **/